/* tslint:disable */
/* eslint-disable */
/**
 * Apperta Physical Health REST API
 * Apperta Physical Health REST API
 *
 * The version of the OpenAPI document: 0.2.0-SNAPSHOT2
 * Contact: info@staircase13.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Represents a request to mark a task as complete
 * @export
 * @interface TaskCompleteDto
 */
export interface TaskCompleteDto {
    /**
     * Id
     * @type {number}
     * @memberof TaskCompleteDto
     */
    id: number;
    /**
     * Task completed time
     * @type {string}
     * @memberof TaskCompleteDto
     */
    complete: string;
}

/**
 * Check if a given object implements the TaskCompleteDto interface.
 */
export function instanceOfTaskCompleteDto(value: object): value is TaskCompleteDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('complete' in value) || value['complete'] === undefined) return false;
    return true;
}

export function TaskCompleteDtoFromJSON(json: any): TaskCompleteDto {
    return TaskCompleteDtoFromJSONTyped(json, false);
}

export function TaskCompleteDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskCompleteDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'complete': json['complete'],
    };
}

export function TaskCompleteDtoToJSON(value?: TaskCompleteDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'complete': value['complete'],
    };
}

